import { render, staticRenderFns } from "./SignatureBanner.vue?vue&type=template&id=2732783d"
import script from "./SignatureBanner.vue?vue&type=script&lang=js"
export * from "./SignatureBanner.vue?vue&type=script&lang=js"
import style0 from "./SignatureBanner.vue?vue&type=style&index=0&id=2732783d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports